import { NgModule } from '@angular/core';
import { CommonModule,DatePipe } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { SendTestProfileService } from './send-test-profile.service';
import { ReactiveFormsModule,FormsModule  } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { SendTestProfileFormComponent } from './form/form.component';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatDatepickerModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { TooltipModule } from 'ngx-bootstrap';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    BrowserAnimationsModule,
    MatInputModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    FormsModule
  ],
  declarations: [
    SendTestProfileFormComponent,
  ]
})
export class SendTestProfileModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SendTestProfileModule,
      providers: [
        SendTestProfileService,
        DatePipe
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/send-test-profile/send-test-profile.module.ts